export default class GroupModel {
    constructor() {
        this.id = undefined;
        this.name ='';
        this.email = '';
        this.code ='';
        this.user = undefined;
        this.users=[];
        this.iconTemporaryFileUrl = '';
    
    }

    static assign(from, to) {
        if (from) {
            to.name = from.id;
            to.code = from.code;
            to.user = from.user;
        } else {
            to = new GroupModel();
        }
    }

    static copy(from) {
        const to = new GroupModel();
        GroupModel.assign(from, to);
        return to;
    }
}
